export const CAPTURED_FILE_PREFIX = 'document-capture-';

export const DEFAULT_CAPTURE_MIME = 'image/jpeg';

export const DEFAULT_CAPTURE_QUALITY = 80;

/**
 * Capacitor Filesystem directories that may hold a secondary copy of a captured
 * photo on Android (`Android/data/<pkg>/files/Pictures/`). Both the returned
 * native path and these are swept after a confirmed upload.
 *
 * DEVICE-TEST-PENDING: confirm the exact secondary-copy location/behavior on a
 * real Android build — this is the open cleanup question in DEV-4252.
 */
export const ANDROID_PICTURES_SUBDIR = 'Pictures';
